import React from "react";
import { styled } from "@mui/material/styles";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";

const StyledTooltip = styled(({ className, arrow = true, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} {...(arrow ? { arrow: true } : {})} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    borderRadius: "8px",
    color: "var(--Color-Text-Primary-On-Light, #1F1F1F)",
    boxShadow: "0px 0px 20px -8px rgba(17, 12, 34, 0.08)",
    fontSize: 11,
    maxWidth: "232px",
    padding: "10px",
    position: "relative"
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.white,
    "&:before": {
      border: "1px solid rgba(0, 0, 0, 0.12)",
      backgroundColor: theme.palette.common.white,
      boxShadow: theme.shadows[1]
    }
  }
}));

export { StyledTooltip };
